import { z } from 'zod';

export const limitsShema = z.object({
  max: z.number(),
  min: z.number()
});

export const tokenShema = z.object({
  required: z.boolean(),
  can_create_new: z.boolean().optional(),
  type: z.string().optional(),
  schema: z
    .array(
      z.object({
        is_key_field: z.boolean().optional(),
        name: z.string(),
        required: z.boolean(),
        type: z.string()
      })
    )
    .optional()
});

const сryptoCurrencySchema = z.object({
  max: z.number(),
  min: z.number(),
  minAmount: z.number(),
  name: z.string(),
  tagRequired: z.boolean()
});

export const basePaymentMethodSchema = z.object({
  service_id: z.number(),
  limits: limitsShema.optional(),
  token: tokenShema,
  has_bonus: z.boolean(),
  crypto_currencies: z.array(сryptoCurrencySchema).optional()
});

export const depositSpecificSchema = basePaymentMethodSchema.extend({
  last_deposit_amount: z.number().optional()
});

export const withdrawSpecificSchema = basePaymentMethodSchema.extend({
  secret_answer_required: z.boolean().optional()
});

export const buyCryptoSchema = z
  .object({
    crypto: z.array(depositSpecificSchema).optional(),
    fiat: z.array(z.string()).optional()
  })
  .optional();

export const getPaymentsResponse = z.object({
  deposit: z.array(depositSpecificSchema),
  withdraw: z.array(withdrawSpecificSchema),
  sellCrypto: z.object({ crypto: z.array(withdrawSpecificSchema) }).optional(),
  buyCrypto: buyCryptoSchema
});

export const getPaymentsResponseDataSchema = z.object({
  response: getPaymentsResponse,
  status: z.literal('ok')
});
